import { editPricingOfAccountSmsCampaign, getPricingOfAccountSmsCampaign } from "../types/account_campaign_pricing_sms_types";

export const getPricingOfAccountSmsCampaignRequest = (payload, cb) => ({
  type: getPricingOfAccountSmsCampaign.GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const getPricingOfAccountSmsCampaignSuccess = (payload) => ({
  type: getPricingOfAccountSmsCampaign.GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_SUCCESS,
  payload,
});
export const getPricingOfAccountSmsCampaignError = (payload) => ({
  type: getPricingOfAccountSmsCampaign.GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_ERROR,
  payload,
});

export const editPricingOfAccountSmsCampaignRequest = (payload, cb) => ({
  type: editPricingOfAccountSmsCampaign.EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const editPricingOfAccountSmsCampaignSuccess = (payload) => ({
  type: editPricingOfAccountSmsCampaign.EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_SUCCESS,
  payload,
});
export const editPricingOfAccountSmsCampaignError = (payload) => ({
  type: editPricingOfAccountSmsCampaign.EDIT_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_ERROR,
  payload,
});
